<script>
import apiConnector from '@/epersonam/apiConnector';
import error from '../error';
import userMedia from '../userMedia';
import reachedLinkChange from './reachedLinkChange';

export default {
  name: 'paiTargets',
  template: '#pai-targets-vue',
  components: {
    error,
    userMedia,
    reachedLinkChange,
  },
  props: [
    'deleteUrl',
    'getUrlIndex',
    'editUrl',
    'createUrl',
    'tabParent',
    'obiettiviTabellati',
    'azioniTabellate',
    'classeTabellata',
    'indicatoriTabellati',
    'risorseTabellate',
  ],
  data() {
    return {
      error: false,
      paiTargets: [],
      POPUP_ANIMATION: 500,
      loaded: false,
    };
  },
  mounted() {
    $(this.tabParent).on('shown', () => {
      if (!this.loaded) {
        this.loadPaiTargets();
      }
    });

    if (location.href.split('#', 2)[1] === $(this.tabParent).prop('href').split('#', 2)[1]) {
      // if page lands on http://...pais/n/edit#tab_pais_targets
      this.loadPaiTargets();
    }
  },
  methods: {
    loadPaiTargets() {
      this.error = false;
      Loader.show();
      apiConnector()
        .get(this.getUrlIndex)
        .then((res) => {
          this.paiTargets = res.data;
          window.Sortable.init();
          Loader.hide();
          this.loaded = true;
        })
        .catch((err) => {
          Loader.hide();
          this.error = true;
        });
    },
    managePaiTarget(res, p_t) {
      $('#content-edit-targets-previous').html(res['data']);
      $('#modal-edit-targets-previous').modal('show');
      window.updateVueInstances();
      // move this in generic function if there is the same problem (reclick save during fade of popup)
      $('#form-management-pais-target').bind('ajax:complete', () => {
        setTimeout(() => {
          $('.modal-footer').removeClass('not-clickable');
        }, this.POPUP_ANIMATION);
      });
      $('#form-management-pais-target').bind('ajax:beforeSend', () => {
        $('.modal-footer').addClass('not-clickable');
      });
      $('#form-management-pais-target').bind('ajax:success', (evt, data, status, xhr) => {
        if (p_t) {
          this.paiTargets = this.paiTargets.map((target) => (target.id === p_t.id ? data : target)).sort((a, b) => a.priority > b.priority);
        } else {
          this.paiTargets.push(data);
          this.paiTargets = this.paiTargets.sort((a, b) => a.priority > b.priority);
        }
        $('#modal-edit-targets-previous').modal('hide');
      });
      window.loadGenericFunction();
      Loader.hide();
    },
    addPaiTarget() {
      this.error = false;
      Loader.show();
      apiConnector()
        .get(this.createUrl)
        .then((res) => {
          this.managePaiTarget(res, null);
        })
        .catch((err) => {
          Loader.hide();
        });
    },
    editPaiTarget(paiTarget) {
      if (!paiTarget.permissions.edit) {
        return;
      }
      this.error = false;
      Loader.show();
      apiConnector()
        .get(this.editUrl.replace('PAIS_TARGET_ID', paiTarget.id))
        .then((res) => {
          this.managePaiTarget(res, paiTarget);
        })
        .catch((err) => {
          Loader.hide();
          this.error = true;
        });
    },
    removePaiTarget(paiTarget) {
      this.error = false;
      Loader.show();
      apiConnector()
        .delete(this.deleteUrl.replace('PAIS_TARGET_ID', paiTarget.id))
        .then((res) => {
          Loader.hide();
          this.paiTargets = this.paiTargets.filter((p) => p !== paiTarget);
        })
        .catch((err) => {
          Loader.hide();
          this.error = true;
        });
    },
  },
};
</script>
